import BadgesSpotlightContainer from './BadgesSpotlight.container';
import BadgesSpotlight from './BadgesSpotlight';
export default BadgesSpotlightContainer(BadgesSpotlight);
